import axiosClient from '../axios-config';

export default {
  getFonts(userId) {
    return axiosClient.get('/users/' + userId + '/user_fonts');
  }
}